<template>
  <div class="knowledge-detail">
    <div class="detail-head">
      <div class="detail-head__num">03</div>
      <div class="detail-head__title">知识点明细</div>
    </div>
    <div>
    <el-table
    :data="showTableList"
    style="width: 100%"
    >
      <div slot="empty" class="no-data">
      <EmptyContent/>
    </div>
    <el-table-column
      prop="tag_name"
      label="知识点名称"
    >
      <template slot-scope="scope">
        <div style="color: #1989FA;">
          {{scope.row.tag_name}}
        </div>
      </template>

    </el-table-column>
      <el-table-column
      prop="avg_ability_before"
      label="学前平均掌握程度"
      align="center"
      width="150"
      sortable
      >
      <template slot-scope="scope">
          {{ Math.floor(scope.row.avg_ability_before*100) }}%
      </template>
    </el-table-column>
      <el-table-column
      prop="avg_ability_after"
      label="学后平均掌握程度"
      align="center"
      width="150"
      sortable
      >
      <template slot-scope="scope">
          {{ Math.floor(scope.row.avg_ability_after*100) }}%
      </template>
    </el-table-column>
      <el-table-column
      prop="avg_ability_change"
      label="掌握程度变化"
      width="150"
      align="center"
      sortable>
        <template slot-scope="scope">
        <div v-if="scope.row.avg_ability_change>0" style="color:#1ABF5F">
          {{'↑'+ Math.floor(scope.row.avg_ability_change *100) }}%
        </div>
        <div v-else-if="scope.row.avg_ability_change<0" style="color:#F2494A">
          {{'↓'+ Math.abs(scope.row.avg_ability_change)}}
        </div>
        <div v-else-if="scope.row.avg_ability_change=0" style="color:#606266">
          {{scope.row.avg_ability_change}}
        </div>
      </template>
    </el-table-column>
    <el-table-column
    prop="study_low_score_count"
      label="学习未掌握次数"
      align="center"
      width="150"
      sortable
      >
       <template slot-scope="scope">
        <div>
          {{scope.row.study_low_score_count+'次'}}
        </div>
      </template>
    </el-table-column>
    </el-table>
    </div>
     <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="dataCount"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50]"
      :current-page="currentPage"
      @size-change="sizeChange"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import EmptyContent from '@/views/pt/components/empty-content.vue';

export default {
  name: 'KnowledgeDetail',
  components: {
    EmptyContent,
  },
  props: {
    subjectId: {
      default: 2,
      type: Number,
    },
    detailList: {
      default: () => [],
      type: Array,
    },
    dataCount: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      showTableList: [],
      currentPage: 1,
      pageSize: 10,
    };
  },
  watch: {
    detailList() {
      this.showTableList = this.detailList;
    },
    subjectId() {
      this.showTableList = this.detailList;
    },
  },
  methods: {
    sizeChange(v) { // 每页条数
      this.currentPage = 1;
      this.pageSize = v;
      this.$emit('sizeChange', this.pageSize);
    },
    currentChange(v) { // 当前页
      // this.currentPage = v;
      this.$emit('currentChange', v);
    },
  },
};
</script>

<style lang="scss" scoped>
.knowledge-detail{
  .detail-head{
    display: flex;
    align-items: center;
    margin-bottom:27px ;
    &__num{
      font-size: 22px;

      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 14px;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
      text-align: center;
    }
    &__title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
     &__info{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(17, 31, 44, 0.6);
    }
  }
  .detail-tip{
    height: 113px;
    margin-bottom: 24px;
    background:
    linear-gradient(180deg, rgba(226, 245, 255, 0.32) 0%, rgba(206, 238, 255, 0.33) 100%);
    border-radius: 8px;
    // opacity: 0.64;
    border: 2px dashed #E3F2FFFF;
    p:first-child{
      margin:24px 0 18px 40px ;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(17, 31, 44, 0.8);
      position: relative;
      &::before{
        content: '';
        width: 5px;
        height: 5px;
        background: rgba(17, 31, 44, 0.77);
        border-radius: 50%;
        left: -8px;
        top: 7px;
        position: absolute;
      }
    }
     p:last-child{
      margin-left:40px ;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(17, 31, 44, 0.8);
      position: relative;
      &::before{
        content: '';
        width: 5px;
        height: 5px;
        background: rgba(17, 31, 44, 0.77);
        border-radius: 50%;
        left: -8px;
        top: 7px;
        position: absolute;
      }
    }
  }
}
::v-deep {
  .el-table{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #606266;
    .el-table__header th {
    background-color: #F0F2F5;;
    }
  }
  .el-pagination {
    margin-top: 20px;
    display: flex;
    width: calc(100% - 64px);
    & .btn-prev {
      margin-left: auto;
    }
  }
}
</style>
